import styled from 'styled-components';

export const TNCList = styled.li`
  list-style-position: inside;
`;
